import { MANUAL_PUSH_STATUS } from 'helpers/constans';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { addZeroBeforeHours } from 'utils';
import SendStatusAction from './SendStatusAction';

const CoundownTime = ({ expireDate, type, pushLogId, triggerRefresh }: { expireDate?: string, type?: string, pushLogId?: string, triggerRefresh?: any}) => {
    const { t, i18n } = useTranslation();

    const [timeRemaining, setTimeRemaining] = useState<any>('');
    const [timeLeft, setTimeLeft] = useState<any>(null);
    const [color, setColor] = useState<string>('warning');

    useEffect(() => {
        const updateTimeLeft = () => {
            const currentDate = moment(moment().tz("Asia/Seoul").format('YYYY-MM-DD HH:mm:ss'));
            const endDateObj = moment(expireDate);
        
            const daysRemaining = endDateObj.diff(currentDate, 'days');
            const hoursRemaining = endDateObj.diff(currentDate, 'hours') % 24;
            const minutesRemaining = endDateObj.diff(currentDate, 'minutes') % 60;
            const secondsRemaining = endDateObj.diff(currentDate, 'seconds') % 60;

            if(type === "coupon") {
                setTimeLeft(`${addZeroBeforeHours(hoursRemaining)}:${addZeroBeforeHours(minutesRemaining)}:${addZeroBeforeHours(secondsRemaining)}`);
                
                if(currentDate.isAfter(endDateObj)) {
                    setTimeLeft(`Expired`);
                    setColor('gray');
                }else if (daysRemaining === 0 && hoursRemaining >= 12 && hoursRemaining < 24) {
                    setColor('orange');
                    setTimeRemaining(0);
                }else if (daysRemaining === 0 && hoursRemaining >= 4 && hoursRemaining < 24) {
                    setColor('orange-yellow');
                    setTimeRemaining(0);
                }else if (daysRemaining === 0 && hoursRemaining < 4) {
                    setColor('danger');
                    setTimeRemaining(0);
                }else {
                    setTimeLeft(expireDate);
                    setColor('primary')
                }
            }else if (type === "push-log") {
                if(hoursRemaining <= 0 && minutesRemaining <= 0 && secondsRemaining <= 0) {
                    setColor('blue');
                    setTimeLeft("processing")
                } else if (daysRemaining === 1 || daysRemaining === 0) {
                    setTimeRemaining(0);
                    setTimeLeft(`${addZeroBeforeHours(hoursRemaining)}:${addZeroBeforeHours(minutesRemaining)}:${addZeroBeforeHours(secondsRemaining)}`);
                }else if(daysRemaining >= 1) {
                    setTimeLeft(`${daysRemaining} ${'days left'}`);
                } 
            }
            else {
                if (daysRemaining === 1 || daysRemaining === 0) {
                    setTimeRemaining(0);
                    setTimeLeft(`${addZeroBeforeHours(hoursRemaining)}:${addZeroBeforeHours(minutesRemaining)}:${addZeroBeforeHours(secondsRemaining)}`);
                }else if(daysRemaining >= 1 && daysRemaining <= 3) {
                    setTimeLeft(`${daysRemaining} ${'days left'}`);
                } 
            }
        };
        
        updateTimeLeft();

        const intervalId = setInterval(() => {
            if (timeLeft && timeRemaining === 0) {
                updateTimeLeft();
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [expireDate, timeLeft])

    if(type === 'push-log') {
        return (<>
            <div className=' d-flex align-items-center justify-content-center'>
                <span className={`rounded-pill badge bg-${timeLeft === 'processing' ? 'blue' : 'warning'}`} >
                    {t(MANUAL_PUSH_STATUS?.find(
                        (item: any) => String(item?.value) === String(timeLeft === 'processing' ? timeLeft : 'waiting')
                    )?.label ?? ""
                    )}
                </span>

                {timeLeft !== 'processing' && <SendStatusAction idPushLog={pushLogId} triggerRefresh={triggerRefresh} />}
            </div>
            
            {timeLeft !== 'processing' && <div className={`text-${color}`}>{timeLeft}</div>}
        </>
        )
        
    } else {
        return <div className={`text-${color}`}>{timeLeft}</div>;
    }
};

export default CoundownTime;